import { OptionRow } from './PaymentSection';

/**
 * Opções das telas de pagamento do Global e do LATAM (liga/desliga por bot).
 * Botões com valor valem nos dois mercados (é a mesma opção nas duas
 * abas); pular a forma de pagamento só existe no Global (o LATAM não tem
 * essa tela).
 */
const OPTIONS = [
    {
        key: 'simple', markets: ['usd', 'mxn'], title: 'Botões com valor',
        hint: 'Cada botão de moeda já mostra o preço convertido: "🇺🇸 USD · $10.00" em vez de "🇺🇸 Dollar (USD)". O comprador compara e escolhe sem precisar ler a mensagem. Vale no Global e no LATAM.',
    },
    {
        key: 'skip', markets: ['usd'], title: 'Pular a escolha da forma de pagamento',
        hint: 'Vai direto para a moeda, com cartão e SPEI na mesma tela.',
    },
];

export default function PaymentOptions({ market, values, onChange }) {
    return (
        <div className="pset-options">
            {OPTIONS.filter((o) => o.markets.includes(market)).map((o) => (
                <OptionRow key={o.key} title={o.title} hint={o.hint} checked={Boolean(values[o.key])}
                    onChange={(on) => onChange({ ...values, [o.key]: on })} />
            ))}
        </div>
    );
}
